import React from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';
import { formatCurrency } from '../../utils/formatters';

const BalanceRibbon = ({ stats, endingBalance, onFinish, onBack, loading }) => {
  const { payments, deposits, clearedBalance, difference, hasUncategorized } = stats;
  const isBalanced = Math.abs(difference) < 0.01;
  const canFinish = isBalanced && !hasUncategorized;

  return (
    <Card className="shadow-sm border-0 mb-4 sticky-top" style={{ top: '20px', zIndex: 1000 }}>
      <Card.Body className="py-3 px-4">
        <Row className="align-items-center">
          <Col md={2}>
            <div className="small text-muted text-uppercase font-weight-bold">Statement End</div>
            <div className="h5 mb-0">{formatCurrency(endingBalance)}</div>
          </Col>
          <Col md={2}>
            <div className="small text-muted text-uppercase font-weight-bold">Payments</div>
            <div className="h5 mb-0 text-danger">-{formatCurrency(payments)}</div>
          </Col>
          <Col md={2}>
            <div className="small text-muted text-uppercase font-weight-bold">Deposits</div>
            <div className="h5 mb-0 text-success">{formatCurrency(deposits)}</div>
          </Col>
          <Col md={2}>
            <div className="small text-muted text-uppercase font-weight-bold">Cleared</div>
            <div className="h5 mb-0">{formatCurrency(clearedBalance)}</div>
          </Col>
          <Col md={2} className="text-center border-left">
            <div className="small text-muted text-uppercase font-weight-bold">Difference</div>
            <div className={`h4 mb-0 ${isBalanced ? 'text-success' : 'text-danger'}`}>
              {formatCurrency(difference)}
            </div>
            {isBalanced && !hasUncategorized && <small className="text-success font-weight-bold">Ready to reconcile!</small>}
            {isBalanced && hasUncategorized && <small className="text-danger font-weight-bold">Categorize all items first</small>}
          </Col>
          <Col md={2} className="text-right">
            <Button 
              variant={canFinish ? "success" : "outline-secondary"} 
              disabled={!canFinish || loading}
              onClick={onFinish}
              size="sm"
              className="font-weight-bold px-3"
            >
              {loading ? 'Processing...' : 'Finish Now'}
            </Button>
            <Button variant="link" size="sm" className="text-muted d-block w-100 mt-1" onClick={onBack}>
              Edit Statement Info
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default BalanceRibbon;
